<template>
    <div></div>
</template>

<script>
import { isFullURI } from '@/utils/common'
export default {
    name: '',
    data() {
        return {

        }
    },
    created() {
        let { redirect, msg } = this.$route.query
        msg && this.$message(msg)
        if (redirect) {
            redirect = decodeURIComponent(redirect)
            if (isFullURI(redirect)) {
                window.location.replace(redirect)
            } else {
                this.$router.replace(redirect)
            }
        } else {
            this.$router.replace('/')
        }
    },
    methods: {

    }
}
</script>

<style lang="less" scoped>
</style>
